/**
 * MotoristaCancelamentoCargaCollection
 *
 * @author Simpli CLI generator
 */
import {PageCollection, HttpExclude, Request} from 'simpli-web-sdk'
import {MotoristaCancelamentoCarga} from '@/model/resource/MotoristaCancelamentoCarga'

/* TODO: review generated class */
@HttpExclude()
export class MotoristaCancelamentoCargaCollection extends PageCollection<
  MotoristaCancelamentoCarga
> {
  constructor() {
    super(MotoristaCancelamentoCarga)
  }

  queryAsPage() {
    return this.listMotoristaCancelamentoCarga()
  }

  async listMotoristaCancelamentoCarga() {
    return await Request.get(`/admin/motorista-cancelamento-carga`, {
      params: this.params,
    })
      .name('listMotoristaCancelamentoCarga')
      .as(this)
      .getResponse()
  }

  async listCsvMotoristaCancelamentoCarga() {
    return await Request.get(`/admin/motorista-cancelamento-carga/csv`, {
      params: this.params,
    })
      .name('listCsvMotoristaCancelamentoCarga')
      .as(this)
      .getResponse()
  }
}
